import {
  GET_DASHBOARD_SEND_TASKS,
  GET_DASHBOARD_SEND_TASKS_SUCCESS,
  GET_DASHBOARD_SEND_TASKS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDashboardSendTasks: '',
  loadingGetDashboardSendTasks: false,
  tasks: null,
  successGetDashboardSendTasks: '',
};

const getDashboardSendTasks = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_SEND_TASKS:
      state = { ...state, loadingGetDashboardSendTasks: true };
      break;
    case GET_DASHBOARD_SEND_TASKS_SUCCESS:
      state = {
        ...state,
        loadingGetDashboardSendTasks: false,
        tasks: action.payload.tasks,
        successGetDashboardSendTasks: action.payload.message,
      };
      break;
    case GET_DASHBOARD_SEND_TASKS_ERROR:
      state = { ...state, errorGetDashboardSendTasks: action.payload, loadingGetDashboardSendTasks: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDashboardSendTasks;
